import {
  RESOURCE_ALLOCATION_PERMISSION,
  RESOURCE_REQUEST_PERMISSION
} from '~/modules/common/enums';
import { useMeContext } from '~/modules/me/useMeContext';

export const getProjectResourceAllocationPermissions = ({
  permissionsMap,
  isPsaRmpEnhancedProjectManagerPersonaEnabled,
  canViewResourceAllocationForProject = false,
  canEditResourceAllocationForProject = false
}) => {
  const isCompletedResourceAllocationEditAllowed = Boolean(
    permissionsMap[
      RESOURCE_ALLOCATION_PERMISSION.WEBUI_EDIT_COMPLETE_RESOURCE_ALLOCATION
    ]
  );
  const canViewResourceAssignments = Boolean(
    permissionsMap[RESOURCE_REQUEST_PERMISSION.VIEW_RESOURCE_ASSIGNMNET]
  );

  return {
    canEditResourceAllocation:
      isCompletedResourceAllocationEditAllowed ||
      (isPsaRmpEnhancedProjectManagerPersonaEnabled &&
        canEditResourceAllocationForProject),
    canViewResourceAllocation: isPsaRmpEnhancedProjectManagerPersonaEnabled
      ? canViewResourceAssignments || canViewResourceAllocationForProject
      : true
  };
};

export const useProjectResourceAllocationPermissions = resourceAllocationActions => {
  const {
    permissionsMap,
    featureFlags: { isPsaRmpEnhancedProjectManagerPersonaEnabled }
  } = useMeContext();

  return getProjectResourceAllocationPermissions({
    permissionsMap,
    isPsaRmpEnhancedProjectManagerPersonaEnabled,
    canViewResourceAllocationForProject:
      resourceAllocationActions?.canViewResourceAllocation,
    canEditResourceAllocationForProject:
      resourceAllocationActions?.canEditResourceAllocation
  });
};
